import { Row, Col } from "react-bootstrap";
import "./PraisePerson.css";

function PraisePerson({
  id,
  userName,
  count,
  language,
  profileName,
  profileNameEnglish,
}) {
  return (
    <Col className="praisePerson">
      <Row id={id} className="align-items-center">
        <Col lg={10}>
          <h5>{userName}</h5>
          <p>{language === "en" ? profileNameEnglish : profileName}</p>
        </Col>
        <Col lg={2} className="right">
          <span className="counter">{count}</span>
        </Col>
      </Row>
    </Col>
  );
}

export default PraisePerson;
